





import PartnersCommissionsContainer from './PartnersCommissionsContainer'
export default PartnersCommissionsContainer
